import { HttpContext, HttpContextToken } from '@angular/common/http';

export const LANGUAGE_HEADER_ENABLED = new HttpContextToken<boolean>(() => false);

export function withLanguageHeader(): HttpContext {
  return new HttpContext().set(LANGUAGE_HEADER_ENABLED, true);
}
